import {SwipeInteractionModule} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionModule';
import {GameBackgroundModule} from 'src/background/GameBackgroundModule';

export class GameSwipeInteractionModule extends SwipeInteractionModule {
	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
	}

	protected onTransitionAnimationStarted(): void {
		this.enableDrag();
	}
}


// WEBPACK FOOTER //
// ./src/swipe/GameSwipeInteractionModule.ts